import React from 'react';
import './Speakers.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Churkin from '../../img/speakers/Churkin.png'
import Botrel from '../../img/speakers/Botrel.png'
import CertiK from '../../img/speakers/CertiK.png'
import ConsenSys from '../../img/speakers/ConsenSys.png'
import Covalent from '../../img/speakers/Covalent.png'
import deBridge from '../../img/speakers/deBridge.png'
import DeliveryHero from '../../img/speakers/Delivery Hero.png'
import Infura from '../../img/speakers/Infura.png'
import Ledingham from '../../img/speakers/Ledingham.png'
import Lupascu from '../../img/speakers/Lupascu.png'
import OMNIAProtocol from '../../img/speakers/OMNIAProtocol.png'
import Ruaro from '../../img/speakers/Ruaro.png'
import Singh from '../../img/speakers/Singh.png'
import Tiu from '../../img/speakers/Tiu.png'
import Magalhães from '../../img/speakers/Magalhães.png'
import immunefi from '../../img/speakers/immunefi.png'
import Salnikov from '../../img/speakers/Salnikov.png'
import rarible from '../../img/speakers/rarible.png'
import Nilsson from '../../img/speakers/Nilsson.png'
import cryptoMegan from '../../img/speakers/cryptoMegan.png'
import Smithmyer from '../../img/speakers/Smithmyer.png'

export default class SpeakersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listJunior: [
                {
                    track: 'Beginner',
                    photo: Tiu,
                    name: 'Vincent Tiu',
                    position: 'Software Engineer',
                    ln: 'https://www.linkedin.com/in/vincetiu8/',
                    logo: Infura,
                    title: `From Layer 0 to Layer 3: the Evolution of Blockchain`,
                    abstract: `An overview of the history of blockchain, from Bitcoin to Ethereum to the latest scaling solutions. Will particularly focus on the technical changes and evolution of blockchain systems to suit different target audiences. No coding knowledge required!`,
                },
                {
                    track: 'Beginner',
                    photo: Ledingham,
                    name: 'Leilani Ledingham',
                    position: 'Product Manager',
                    tw: 'https://twitter.com/leichain',
                    logo: Covalent,
                    title: `Careers in Web3`,
                    abstract: `How does one transition into a Web3 role and what are some of the challenges faced in this fast-growing industry? Careers in Web3 covers everything from the type of job opportunities to the product landscape to the easiest way to actually join a company.`,
                },
                {
                    track: 'Beginner',
                    photo: Singh,
                    name: 'Vijay Pratap Singh',
                    position: 'Senior Software Engineer',
                    ln: 'https://www.linkedin.com/in/vijay-pratapsingh/',
                    logo: DeliveryHero,
                    title: `Introduction to Ethereum and Solidity`,
                    abstract: `What Why and How to Ethereum.
                    What Why and How to Solidity?
                    What Why and How to Smart Contracts
                    Demo Application
                    Essential Blockchain Developer Tools`,
                },
                {
                    track: 'Beginner',
                    photo: Magalhães,
                    name: 'Gonçalo Magalhães',
                    position: 'Solidity developer, Whitehat scholar, Lead Teacher',
                    ln: 'https://www.linkedin.com/in/goncalo-magalhaes-dev/',
                    tw: 'https://twitter.com/GonRMagalhaes',
                    github: 'https://github.com/goncaloMagalhaes',
                    logo: immunefi,
                    title: `Blockchain development roadmap`,
                    abstract: `The blockchain space is just so damn overwhelming. Here's a speedrun and a concrete roadmap for junior developers to follow steadily`,
                },
                {
                    track: 'Beginner',
                    photo: Salnikov,
                    name: 'Alexander Salnikov',
                    position: 'CPO/Cofounder',
                    ln: 'https://www.linkedin.com/in/salnikov1/',
                    github: 'https://angel.co/u/insider0x',
                    logo: rarible,
                    title: `Private property in Metaverse: Why NFTs matter?`,
                    abstract: `You live in a metaverse! Just take a look at your Screen Time. Over the last decade user-generated content has been hosted, controlled and monetized by big tech. Today, new generation of services is built by the best engineers enabling a direct user ownership of things such as art, profile pictures, in game assets, digital land and soon even villas. During this talk we’ll cover how this created a $25 billion market in 2021 and what lays ahead of us in terms of use-cases, technology, opportunities of the NFT market`,
                },
            ],
            listJuniorHide: [
                {
                    track: 'Beginner',
                    photo: Nilsson,
                    name: 'Megan Nilsson',
                    position: 'High-end crypto and NFT portfolio consultant',
                    inst: 'https://www.instagram.com/cryptomegan/',
                    logo: cryptoMegan,
                    title: `NFTs and the Dawn of the Metaverse, a $1 trillion revenue opportunity`,
                    abstract: `Opportunities in NFTs and the metaverse, and how they will revolutionize brands, businesses and entire industries`,
                },
                // {
                //     track: 'Junior',
                //     photo: Richardson,
                //     name: 'Rob Richardson',
                //     position: '',
                //     ln: '',
                //     tw: '',
                //     github: '',
                //     website: '',
                //     logo: Jetpackio,
                //     title: '',
                //     abstract: ``,
                // },
            ],
            listSenior: [
                {
                    track: 'Pro',
                    photo: Botrel,
                    name: 'Gautam Botrel',
                    position: 'Lead R&D Engineer',
                    tw: 'https://twitter.com/gbo_eth',
                    logo: ConsenSys,
                    title: `gnark: [fast] zkSNARKs in Go`,
                    abstract: `zkSNARKs and zero knowledge proofs are blooming. They belong at the core of the roadmap of important ecosystems like Ethereum, as they are a very useful cryptographic primitive to help solve scalability and privacy issues. The goal of this presentation is to give a general overview to where we are at in 2022 in this field, and to explain, for non-cryptographers (ie software engineers) how to design, code and run a zkSNARK circuit.`,
                },
                {
                    track: 'Pro',
                    photo: Lupascu,
                    name: 'Alexandru Lupascu',
                    position: 'CTO',
                    tw: 'https://www.linkedin.com/in/alexandru-lupascu',
                    logo: OMNIAProtocol,
                    title: `Ensuring privacy and security in Web3`,
                    abstract: `Lack of privacy in web3 not only that it impacts your personal safety but it actually costs you money via front-running and sandwiching attacks that are exploiting the lack of pre-mining transaction privacy. Apart from that, security and protection against scams, fraud, etc. must be ensured at the infrastructure layer.`,
                },
                {
                    track: 'Pro',
                    photo: Ruaro,
                    name: 'Neil Ruaro',
                    position: 'Software Engineer',
                    ln: 'https://www.linkedin.com/in/eruaro/',
                    logo: CertiK,
                    title: `Developing your first Blockchain with Cosmos`,
                    abstract: `This talk will be a workshop on blockchain development with the Cosmos SDK`,
                },
                {
                    track: 'Pro',
                    photo: Tiu,
                    name: 'Vincent Tiu',
                    position: 'Software Engineer',
                    ln: 'https://www.linkedin.com/in/vincetiu8/',
                    logo: Infura,
                    title: `How to start careers in web 3`,
                    abstract: `Deep dive into the different Ethereum scaling solutions and their use-cases. Will focus more on conceptual understanding as coding for these EVM-based scaling solutions is mostly the same as coding for Ethereum.`,
                },
                {
                    track: 'Pro',
                    photo: Churkin,
                    name: 'Alexey Churkin',
                    position: 'Senior Solidity Engineer',
                    tw: 'https://twitter.com/alexeychr',
                    logo: deBridge,
                    title: `Building secure and decentralized cross-chain applications`,
                    abstract: `Given all the features blockchains provide to the world including decentralization, consensus, immutability, and data consistency, there always has been a tradeoff of inevitable isolation. Each blockchain is a siloed ecosystem, a universe that cannot establish trusted bi-directional communicational channels with other blockchains. Or can it be done today? Yes, it is possible to scale dApps and protocols across various EVM chains by actively initiating cross-chain interoperability channels between contracts that reside on different blockchains. All without a tradeoff of reduced security and trust. From this talk, you will learn about different capabilities facilitated by deBridge and the building blocks of cross-chain interoperability over its decentralized infrastructure.`,
                },
            ],
            listSeniorHide: [
                {
                    track: 'Pro',
                    photo: Magalhães,
                    name: 'Gonçalo Magalhães',
                    position: 'Solidity developer, Whitehat scholar, Lead Teacher',
                    ln: 'https://www.linkedin.com/in/goncalo-magalhaes-dev/',
                    tw: 'https://twitter.com/GonRMagalhaes',
                    github: 'https://github.com/goncaloMagalhaes',
                    logo: immunefi,
                    title: `EVM deep dive`,
                    abstract: `EVM fundamentals are absolutely key for a blockchain developer to fully grasp the technology. In this presentation, my intention would be to do kind of a speedrun of the EVM architecture, to later on focus on the opcode level. Would be quite interesting to actually do a hands-on evm assembly programming, understanding the bytecode level and being able to connect the concepts between the solidity programming and the low-level bytecode that's actually run by the Ethereum Virtual Machine.`,
                },
                {
                    track: 'Pro',
                    photo: Smithmyer,
                    name: 'Christopher Smithmyer',
                    position: 'CEO/Co-Founder at BlackWallet Limited',
                    ln: 'https://www.linkedin.com/in/christopher-smithmyer',
                    title: `Building a Better System: Ceasing the War Against Ourselves`,
                    abstract: `The four topic areas i discussed with Karine are:
                    Stablecoin 2.0- basing stability on something other than unstable fiat currency.
                    Smart Burn Technology- Moving away from the environmentally destructive methodologies of traditional burns and zombie wallets.
                    Communal Ecosystem Development- How standing alone in the cryptoverse is what is allowing central banks to eat us alive.
                    Quantum Entanglement in Crypto- the underlying inter-connectivity of cryptoverse and how it effects us all.
                    These can also be one speech with less time on each topic.`,
                },
                // {
                //     id: 20,
                //     track: 'Senior',
                //     photo: Richardson,
                //     name: 'Rob Richardson',
                //     position: '',
                //     ln: '',
                //     tw: '',
                //     github: '',
                //     website: '',
                //     logo: Jetpackio,
                //     title: '',
                //     abstract: ``,
                // },
            ],
        }
    }

    render() {
        return (
            <div className="speakers" id='speakers'>
                <VideoPresent speakersJunior={this.state.listJunior} speakersSenior={this.state.listSenior} speakersJuniorHide={this.state.listJuniorHide} speakerSeniorHide={this.state.listSeniorHide} />
            </div>
        );
    }
};